import { render, staticRenderFns } from "./SubscriberSettings.vue?vue&type=template&id=4adefdcb&"
import script from "./SubscriberSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriberSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports